/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  InsertNewTenantOptions,
  InsertNewTenantStatus201,
  InsertNewTenantStatus400,
  InsertNewTenantStatus500,
} from '../types/InsertNewTenant'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { insertNewTenant } from '../clients/insertNewTenant'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const insertNewTenantMutationKey = () => [{ url: '/v1/tenants' }] as const

export function insertNewTenantMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = insertNewTenantMutationKey()
  return mutationOptions<
    InsertNewTenantStatus201,
    ResponseErrorConfig<InsertNewTenantStatus400 | InsertNewTenantStatus500>,
    InsertNewTenantOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return insertNewTenant({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Insert tenant details by admin
 * {@link /v1/tenants}
 */
export function useInsertNewTenant<TContext>(
  options: {
    mutation?: UseMutationOptions<
      InsertNewTenantStatus201,
      ResponseErrorConfig<InsertNewTenantStatus400 | InsertNewTenantStatus500>,
      InsertNewTenantOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? insertNewTenantMutationKey()

  const baseOptions = insertNewTenantMutationOptions(config) as UseMutationOptions<
    InsertNewTenantStatus201,
    ResponseErrorConfig<InsertNewTenantStatus400 | InsertNewTenantStatus500>,
    InsertNewTenantOptions,
    TContext
  >

  return useMutation<
    InsertNewTenantStatus201,
    ResponseErrorConfig<InsertNewTenantStatus400 | InsertNewTenantStatus500>,
    InsertNewTenantOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    InsertNewTenantStatus201,
    ResponseErrorConfig<InsertNewTenantStatus400 | InsertNewTenantStatus500>,
    InsertNewTenantOptions,
    TContext
  >
}
